import * as Data from './archibus-v2/DataApi'
import * as Document from './archibus/DocumentApi'

const getEmployeePhotos = ({data}) => {
  return Promise.all(
    data.map(item => {
      if (item.emPhoto) {
        return Document.getTempDocumentUrl(
          'em',
          {em_id: item.emId},
          'em_photo'
        ).then(url => {
          item.url = encodeURI(url)
          return Promise.resolve(item)
        })
      } else {
        return Promise.resolve({...item, url: null})
      }
    })
  )
}

const fetchEmployees = ({restriction = null}) => {
  return Data.getDataFromDataSource(
    'ab-selfservice-dashboard.axvw',
    'employees',
    restriction
  )
    .then(result => {
      const {data} = result
      return getEmployeePhotos({data})
    })
    .then(employees => Promise.resolve(employees))
}

export const fetchManagerEmployees = ({emId}) => {
  let restriction = new Ab.view.Restriction()
  restriction.addClause('em.manager', emId, '=', ')OR(')
  restriction.addClause('dp.head', emId, '=', ')OR(')

  return fetchEmployees({restriction})
}

export const fetchDepartmentEmployees = ({dvId, dpId}) => {
  let restriction = new Ab.view.Restriction()
  restriction.addClause('em.dv_id', dvId)
  restriction.addClause('em.dp_id', dpId)

  return fetchEmployees({restriction})
}

export const fetchLocationEmployees = ({blId}) => {
  let restriction = new Ab.view.Restriction()
  restriction.addClause('em.bl_id', blId)
  restriction.addClause('em.rm_id', null, 'IS NOT NULL')

  return fetchEmployees({restriction})
}

export const fetchLocationEmployee = ({blId, flId, rmId}) => {
  let restriction = new Ab.view.Restriction()
  restriction.addClause('em.bl_id', blId)
  restriction.addClause('em.fl_id', flId)
  restriction.addClause('em.rm_id', rmId)

  return fetchEmployees({restriction})
}